import { fetchSearchedProducts } from "src/services/SearchApi";
import { getImageUrl } from "src/utils/imageUrl";

export const fetchAndSetSearchProducts = async (
  query,
  setSearchResults,
  setError,
  setIsLoading
) => {
  try {
    setError(null);
    const results = await fetchSearchedProducts(query);
    const processedResults = Array.isArray(results)
      ? results.map((item) => ({
          ...item,
          image:
            item?.images && item.images.length > 0
              ? getImageUrl(item.images[0].imagePath)
              : item.image,
        }))
      : [];
    setSearchResults(processedResults);
  } catch (error) {
    console.error("Search error:", error);
    setSearchResults([]);
    setError("An error occurred while searching. Please try again.");
  } finally {
    setIsLoading(false);
  }
};
